import React from "react";
import { Switch } from "antd";
import styled from "styled-components";

const StyledSwitch = styled(Switch)`
  /* 移除硬编码的背景色，让主题配置生效 */
`;

interface BooleanSetterProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export const BooleanSetter: React.FC<BooleanSetterProps> = ({
  value,
  onChange,
}) => {
  return <StyledSwitch checked={value} onChange={onChange} />;
};
